import React from 'react';
import TranslationService from "../../../app/services/TranslationService";


export class NotesList extends React.Component {
    constructor(props)
    {
        super(props);

        this.state = {
            opened: false
        };
    };

    listClass = () => {
        if (this.state.opened) {
            return 'selectable-list opened';
        }

        return 'selectable-list list';
    };

    elementOpen = (id) => {
        this.setState({
            opened: false
        });
        this.props.openElement(id);
    };

    getOpenedTitle = () => {
        let title = TranslationService.trans(this.props.language, 'note.select_note');

        let that = this;
        Object.keys(this.props.notes).forEach(function(key) {
            if (that.props.notes[key].id === that.props.noteId) {
                title = that.props.notes[key].title;
            }
        });

        return title;
    }

    renderData = () => {
        let rows = [];

        let that = this;
        Object.keys(this.props.notes).forEach(function(key) {
            rows.push(<div className={'imd-border-color-accent element' + (that.props.notes[key].id === that.props.noteId ? ' active' : '')}
                onClick={() => that.elementOpen(that.props.notes[key].id)}
                key={key}
            >
                <span className="imd-text-main">
                    {that.props.notes[key].title}
                </span>
            </div>);
        });

        return rows;
    };

    render() {
        return (
            <div className={this.listClass()}>
                <div className="list">
                    {this.renderData()}
                </div>

                <div className="imd-bg-20-default imd-border-color-main active-element" onClick={() => this.setState({opened: true})}>
                    <span>{this.getOpenedTitle()}</span>
                </div>
            </div>
        );
    }
}
